module.exports = __webpack_public_path__ + "img/doll-clench-zoom.f3c5275e.png";